module.exports = __webpack_public_path__ + "roboto-regular-webfont-77dc6a0145954a963b95d30773543105.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-regular-webfont.svg
// module id = 867
// module chunks = 86